module.exports = __webpack_public_path__ + "img/Welcome_Home.1f90643c.png";